export const SET_AI_LOADER = "SET_AI_LOADER"
export const UPLOAD_PRODUCT_DESCRIPTION = "UPLOAD_PRODUCT_DESCRIPTION"
export const TRACK_PRODUCT_DESCRIPTION = "TRACK_PRODUCT_DESCRIPTION"
export const SET_TRACK_PRODUCT_DESCRIPTION = "SET_TRACK_PRODUCT_DESCRIPTION"

